import type { AutocompleteBounds } from 'shared/search/types';
import { fetchJson } from './fetchJson';

export const fetchAutocompleteBounds = async (autocompleteUrl: string, query: string): Promise<AutocompleteBounds | null> =>
    fetchJson<Array<{ bounds?: AutocompleteBounds }>>(`${autocompleteUrl}${query}`)
        .then((json) => json[0]?.bounds ?? null)
        .catch((err) => {
            console.warn(`Failed to fetch autocomplete bounds for "${query}":`, err);
            return null;
        });

export const boundsToString = (bounds: AutocompleteBounds): string =>
    `${bounds.southwest_lat},${bounds.southwest_lng},${bounds.northeast_lat},${bounds.northeast_lng}`;
